import { render, staticRenderFns } from "./CourseEnrollLayout1.vue?vue&type=template&id=fa754e06&"
import script from "./CourseEnrollLayout1.vue?vue&type=script&lang=js&"
export * from "./CourseEnrollLayout1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports